import { useEffect } from 'react'
import { CONFIG } from '@/config'

export function useDocumentTitle(title: string) {
  useEffect(() => {
    const appName = CONFIG.CLIENT.name || 'Catering'
    document.title = title ? `${title} · ${appName}` : appName
    return () => { document.title = appName }
  }, [title])
}
